module.exports = { raw: '9.4.2' };



//////////////////
// WEBPACK FOOTER
// ./src/version.js
// module id = 10
// module chunks = 0 1